import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  Alert,
  Button,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FormatTime from "../../AdsPage/FormatTime";
import {
  cardOutline,
  fonts,
  headingFonts,
  mainButtonStyles,
} from "../../../Styles/Styles";
import LoadingAnimation from "../../Animations/LoadingAnimation";

export default function SubscribersManagement() {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSubscribers = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_SERVER_BASE_URL}/contact/all-subscribers`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch subscribers");
        }
        const data = await response.json();
        setSubscribers(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscribers();
  }, []);

  const handleExportEmails = () => {
    window.open(
      `${process.env.REACT_APP_API_SERVER_BASE_URL}/contact/export-subscribers`,
      "_blank"
    );
  };

  if (loading) {
    return <LoadingAnimation />;
  }

  return (
    <Box sx={{ p: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h5" sx={{ ...headingFonts }}>
          Subscribers Management
        </Typography>
        <Button
          onClick={handleExportEmails}
          className="main-button-style"
          sx={{ ...mainButtonStyles }}
        >
          <>
            <span>Export Emails</span>
            <FileDownloadIcon />
          </>
        </Button>
      </Box>
      {error && <Alert severity="error">{error}</Alert>}

      {!loading && !error && (
        <TableContainer sx={{ ...cardOutline }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ ...headingFonts }}>Email</TableCell>
                <TableCell sx={{ ...headingFonts }}>Date Subscribed</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {subscribers.length > 0 ? (
                subscribers.map((subscriber) => (
                  <TableRow key={subscriber._id}>
                    <TableCell sx={{ ...fonts }}>{subscriber.email}</TableCell>
                    <TableCell sx={{ ...fonts }}>
                      <FormatTime createdAt={subscriber.subscribedAt} />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={2} align="center" sx={{ ...fonts }}>
                    No subscribers found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
